import styles from "./halloween-background.module.less";

const HalloweenBackground = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.batWrapper}>
        <BatElement />
      </div>
      <div className={styles.spiderWrapper}>
        <SpiderRightElement />
      </div>
    </div>
  );
};

export default HalloweenBackground;

const BatElement = () => <img src="/background-images/halloween/bats.svg" />;

const SpiderRightElement = () => <img src="/background-images/halloween/spider-web.svg" />;
